function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m4 3.5c-1.38071 0-2.5 1.11929-2.5 2.5v10c0 1.3807 1.11929 2.5 2.5 2.5h6.191l-1.00002 2h-2.19098c-.27614 0-.5.2239-.5.5s.22386.5.5.5h2.48918c.00696.0001.01392.0001.02087 0h4.97995c.0069.0001.0138.0001.0208 0h2.4892c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5h-2.191l-1-2h6.191c1.3807 0 2.5-1.1193 2.5-2.5v-10c0-1.38071-1.1193-2.5-2.5-2.5zm9.691 17-1-2h-1.382l-1 2zm-.7019-3c.007-.0001.014-.0001.021 0h6.9899c.8284 0 1.5-.6716 1.5-1.5v-10c0-.82843-.6716-1.5-1.5-1.5h-16c-.82843 0-1.5.67157-1.5 1.5v10c0 .8284.67157 1.5 1.5 1.5h6.9899c.007-.0001.014-.0001.0209 0z",
  fill: "rgb(0,0,0)",
  fillRule: "evenodd"
});

function SvgUndernav1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndernav1);
export default __webpack_public_path__ + "static/media/undernav1.5f292f29.svg";
export { ForwardRef as ReactComponent };